import { baseUniDriverFactory } from '../test-utils/utils/unidriver';
import { tooltipDriverFactory } from '../Tooltip/Tooltip.uni.driver';
import { dataHooks } from './constants';

export const statusIndicatorDriverFactory = (base, body) => {
  const getTooltipDriver = () =>
    tooltipDriverFactory(base.$(`[data-hook="${dataHooks.tooltip}"]`), body);

  return {
    ...baseUniDriverFactory(base, body),

    /** Returns the type of the status oneOf(error, warning, loading) */
    getStatus: () => base.attr('data-status'),

    /** Returns true iff a message was provided */
    hasMessage: () => getTooltipDriver().exists(),

    /** Returns the message text */
    getMessage: async () => getTooltipDriver().getTooltipText(),
  };
};
